<script setup lang="ts">
import { Head, Link } from '@inertiajs/vue3'
import { library } from "@fortawesome/fontawesome-svg-core"
import { faExclamationTriangle } from '@fal'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'

library.add(faExclamationTriangle)

defineProps<{
    pageHead?: PageHeadingTS
    title: string
    low_stock_product: { id: number; name: string; code: string; quantity: number; slug: string }[]
}>()
</script>

<template>
    <Head :title="title" />
    <PageHeading :data="pageHead" />

    <div class="px-8 py-6">

        <!-- Low Stock Alert -->
        <div v-if="low_stock_product.length" class="rounded-lg border border-amber-200 bg-amber-50 p-4">
            <div class="flex gap-x-3">
                <FontAwesomeIcon icon="fal fa-exclamation-triangle" class="mt-0.5 text-amber-500 shrink-0" fixed-width aria-hidden="true" />
                <div class="flex-1">
                    <h3 class="text-sm font-semibold text-amber-800">
                        {{ low_stock_product.length }} produk memiliki stok rendah (≤ 15)
                    </h3>
                    <ul class="mt-2 divide-y divide-amber-100">
                        <li
                            v-for="product in low_stock_product"
                            :key="product.id"
                            class="flex items-center justify-between py-1.5"
                        >
                            <span class="text-sm text-amber-900">
                                <span class="font-mono text-xs text-amber-600 mr-2">{{ product.code }}</span>
                                {{ product.name }}
                            </span>
                            <div class="flex items-center gap-x-3">
                                <span
                                    class="text-sm font-semibold tabular-nums"
                                    :class="product.quantity === 0 ? 'text-red-600' : 'text-amber-700'"
                                >
                                    {{ product.quantity }} pcs
                                </span>
                                <Link
                                    :href="route('casheer.products.show', product.slug)"
                                    class="text-xs text-amber-600 hover:text-amber-800 hover:underline"
                                >
                                    Detail →
                                </Link>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-else class="rounded-lg border border-dashed border-gray-200 px-6 py-12 text-center text-sm text-gray-400">
            Semua produk memiliki stok yang cukup.
        </div>

    </div>
</template>